import {Redirect} from 'expo-router';
import {useSession} from "@/lib/auth/auth";

export default function Index() {
    const {session} = useSession();
    if (!!session) {
        return <Redirect href="/u/account"/>;
    } else {
        return <Redirect href="/u/account/login"/>;
    }
}